{
  "fr": {
    "issue_status": {
      "actions": {
        "create": "Créer un statut de problème"
      },
      "labels": {
        "customer_status": "Le client verra",
        "internal_status": "Statut interne",
        "new_issue_status": "Statut"
      }
    }
  }
}